// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"dc8ff898","488":"ed4f0aff","551":"80ae024f","643":"4480bcde","685":"c9778953","851":"ff2a38c4","950":"86963476"}[chunkId] + ".chunk.js";
};